import { render, staticRenderFns } from "./dynamic-wrapper.vue?vue&type=template&id=7d613979&"
import script from "./dynamic-wrapper.vue?vue&type=script&lang=js&"
export * from "./dynamic-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dynamic-wrapper.vue"
export default component.exports